import React from "react";
import { css } from "@emotion/react";
import { FormattedMessage } from "react-intl";
import { colors, margins, fontSize } from "style";
import { Col, Row } from "components/Containers";
import { Tag, TAG_SIZE } from "components/Tags";
import { H3 } from "components/Text";

/**
 * ProfileResumeAutoFillHeader
 */
const ProfileResumeAutoFillHeader = () => (
  <Col gap={margins.xxxsmall}>
    <Row css={styles.header}>
      <H3>
        <FormattedMessage id="Profile.ProfileResumeAutoFill.H3" />
      </H3>

      <Tag size={TAG_SIZE.small} color={colors.purpleRainLight5} background={colors.purpleRainBase}>
        <FormattedMessage id="Profile.ProfileResumeAutoFill.New" />
      </Tag>
    </Row>

    <p css={styles.description}>
      <FormattedMessage id="Profile.ProfileResumeAutoFill.Description" />
    </p>
  </Col>
);

const styles = {
  header: css`
    flex-wrap: wrap;
    gap: ${margins.xxxsmall};
  `,
  description: css`
    margin: 0;
    color: ${colors.grayAnatomyBase};
    font-size: ${fontSize.small};
    line-height: 1.5;
  `,
};

export default ProfileResumeAutoFillHeader;
